import { useMemo } from "react";

import useUserStore from "@store/useUserStore";
import { AVAILABLE_GROUP_LABELS_FOR_PIPELINE_STAGE_SELECT } from "@config/constants";

export const DEFAULT_NO_STAGE_LABEL = AVAILABLE_GROUP_LABELS_FOR_PIPELINE_STAGE_SELECT.NO_STAGE;

/**
 * Hook to get the customizable "No Stage" label per organization.
 * Returns the organization's custom label if set, otherwise returns "No Stage".
 */
export function useNoStageLabel(): string {
  const activeUser = useUserStore((state) => state.activeUser);

  return useMemo(() => {
    return activeUser?.organization?.settings?.default_stage_label || DEFAULT_NO_STAGE_LABEL;
  }, [activeUser?.organization?.settings?.default_stage_label]);
}
